// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1E3N_","title":"Info_title__2J2Az","links":"Info_links__34tEb","link":"Info_link__3DcsP","logo":"Info_logo__lu8ls"};